import styles from './ElevioTooltip.module.css';
import HelpTooltip from '../HelpTooltip';
import i18n from '../../../../i18n';
import clsx from 'clsx';

interface TitleHelpToolTipProps {
  elevioId: string;
  id?: string;
  title?: string;
  className?: string;
}

/**
 * Wrapper of the elevio tooltip.
 * @constructor
 */
const ElevioTooltip = (props: TitleHelpToolTipProps) => {
  return (
    <span
      title={props.title ? props.title : i18n.t('common:showHelp')}
      id={props.id}
      className={clsx(styles.questionNearTitle, props.className)}
    >
      <HelpTooltip id={props.elevioId} />
    </span>
  );
};

export default ElevioTooltip;
